var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
// tslint:disable:max-line-length
// This file is generated by generateStyles script.
// Please don't edit it manually.
import * as React from "react";
import "../../less/svg/ScrollArrowLeft.less";
export var ScrollArrowLeft = function (props) { return (React.createElement("svg", { viewBox: "0 0 34.91 60.13" },
    React.createElement("defs", null),
    React.createElement("g", __assign({ id: "Layer_2" }, props, { className: "ScrollArrowLeft " + props.className }),
        React.createElement("g", { id: "Leagues" },
            React.createElement("g", { id: "Info_and_rewards", "data-name": "Info and rewards" },
                React.createElement("g", { id: "ScrollArrowLeft" },
                    React.createElement("path", { className: "cls-1", d: "M29.18 60.13a5.73 5.73 0 0 0 5.73-5.72V5.72A5.73 5.73 0 0 0 29.18 0a5.66 5.66 0 0 0-3.94 1.6L3 23a9.8 9.8 0 0 0 0 14.13l22.24 21.39a5.63 5.63 0 0 0 3.94 1.61z" }),
                    React.createElement("path", { className: "cls-2", d: "M26.8 3.22L4.57 24.62a7.56 7.56 0 0 0 0 10.89L26.8 56.9a3.46 3.46 0 0 0 5.86-2.49V5.72a3.46 3.46 0 0 0-5.86-2.5z" }),
                    React.createElement("path", { className: "cls-3", d: "M10.78 30.06l12.87 19.48-19.08-14a7.56 7.56 0 0 1 0-10.89l19.08-14z" }),
                    React.createElement("path", { className: "cls-4", d: "M29.18 5.25a.48.48 0 0 1 .48.47v48.69c0 .45-.48.47-.48.47a.42.42 0 0 1-.3-.14L6.65 33.34a4.54 4.54 0 0 1 0-6.56L28.88 5.39a.42.42 0 0 1 .3-.14m0-3a3.41 3.41 0 0 0-2.38 1L4.57 24.62a7.56 7.56 0 0 0 0 10.89L26.8 56.9a3.42 3.42 0 0 0 2.38 1 3.46 3.46 0 0 0 3.48-3.47V5.72a3.46 3.46 0 0 0-3.48-3.47z" }))))))); };



//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/ScrollArrowLeft.tsx
// module id = 2782
// module chunks = 3